var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autocomplete-container"},[_c('input',{ref:"dawa",staticClass:"form-input",attrs:{"placeholder":"Skriv for at søge","type":"search"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }